// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import { memo } from "react";


function RevisedTimelineBodyCell({ children, leftBorder, maxWidth = "100%" }) {
  return (
    <SoftBox
      component="td"
      display={leftBorder ? "flex" : "table-cell"}
      width={maxWidth}
      sx={() => ({
        pr: leftBorder ? 0 : 1, position: "relative",
        minWidth: {
          xxs: `${maxWidth.xxs} !important`,
          sm: `${maxWidth.sm} !important`,
        },
        maxWidth: {
          xxs: `${maxWidth.xxs} !important`,
          sm: `${maxWidth.sm} !important`,
        },
      })}>
      <SoftBox display="inline-block" width="100%"
        sx={{
          maxWidth: {
            xxs: `${maxWidth.xxs} !important`,
            sm: `${maxWidth.sm} !important`,
          },
          verticalAlign: "middle"
        }}>
        {children}
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props for the RevisedTimelineBodyCell
RevisedTimelineBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  leftBorder: PropTypes.bool,
  maxWidth: PropTypes.string,
};

export default memo(RevisedTimelineBodyCell);
